import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('items'),
    item: defineMessage('item'),
    units: defineMessage('units'),
    priceLevel: defineMessage('price_level'),
    quantity: defineMessage('quantity'),
    description: defineMessage('description'),
    rate: defineMessage('rate'),
    amount: defineMessage('amount'),
    taxCode: defineMessage('tax_code'),
    taxRate: defineMessage('tax_rate'),
    taxAmount: defineMessage('tax_amount'),
    grossAmount: defineMessage('gross_amount'),
    department: defineMessage('department'),
    class: defineMessage('class'),
    location: defineMessage('location'),
};
